import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "../../store";
import { Box, Grid, useMediaQuery } from "@mui/material";
import theme from "../../theme";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Inputs } from "../formInputs";
import { HexColorPicker } from "react-colorful";
import { Base } from "../base";
import { editHighlight, postHighlight } from "../../slices/calendarHighlight";

interface Props {
  close: () => void;
  onSave: () => void;
}

const AddEditCalendarHighlightForm: React.FC<Props> = (props) => {
  const { close, onSave } = props;
  const dispatch = useDispatch();
  const { highlight, status } = useSelector((store) => store.highlight);
  const xs = useMediaQuery(theme.breakpoints.down("sm"));
  const [color, setColor] = useState(highlight.color);
  useEffect(() => {
    if (!!highlight.color && !color) {
      setColor(highlight.color);
    }
  }, [highlight.color, color]);

  const updateAfterChanged = () => {
    close();
    if (xs) {
      onSave();
    }
  };

  const handleSubmit = (values: any) => {
    if (values.id === 0) {
      dispatch(postHighlight(values)).then(({ meta }) => {
        if (meta.requestStatus === "fulfilled") {
          updateAfterChanged();
        }
      });
    } else {
      dispatch(editHighlight(values)).then(({ meta }) => {
        if (meta.requestStatus === "fulfilled") {
          updateAfterChanged();
        }
      });
    }
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Required"),
    color: Yup.string().required("Required"),
  });

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.paper,
        width: 300,
        borderRadius: "10px",
        padding: "15px",
      }}
    >
      <Formik
        initialValues={highlight}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
        enableReinitialize
      >
        {({ setFieldValue, errors }) => (
          <Form noValidate>
            <Grid container>
              <Grid size={12}>
                <Field
                  component={Inputs.Text}
                  name="name"
                  label="Name"
                  required
                />
              </Grid>
              <Grid size={12}>
                <HexColorPicker
                  color={color}
                  onChange={(c) => {
                    setColor(c);
                    setFieldValue("color", c);
                  }}
                  style={{ width: "100%" }}
                />
                <Grid
                  sx={{
                    color: theme.palette.error.main,
                    padding: errors.color ? 0 : "12px",
                  }}
                >
                  <Base.Text
                    text={errors.color || ""}
                    variant="subtitle1"
                    component="span"
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid container direction={"row"} justifyContent={"space-between"}>
              <Grid>
                <Base.Button text="Cancel" type="secondary" onClick={close} />
              </Grid>
              <Grid>
                <Inputs.Submit
                  isSubmitting={status === "loading"}
                  text={"Save"}
                />
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default AddEditCalendarHighlightForm;
